module.exports = __webpack_public_path__ + "img/H02058-02.270e378b.jpg";